module.exports = __webpack_public_path__ + "img/神领物流.844636c1.png";